import { useQuery } from 'react-query';
import { ReceiptPUB } from '../../../types/models/receipt/receipt.types';
import { UseAllReceiptsPUBOptions } from './useAllReceiptsPUB.types';
import { queryAllReceiptsPUB } from './useAllReceiptsPUB.query';
import { ConsultationAlert } from '../../../types/models/consultations/consultationAlert.types';

export const ALL_RECEIPTS_PUB_QUERY_KEY = 'ALL_RECEIPTS_PUB';

export const useAllReceiptsPUB = (options?: UseAllReceiptsPUBOptions) => {
  return useQuery<(ReceiptPUB & ConsultationAlert)[], Error>(
    ALL_RECEIPTS_PUB_QUERY_KEY,
    () => queryAllReceiptsPUB(),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
